/** @type {import('next-i18next').UserConfig} */
module.exports = {
    appendNamespaceToMissingKey: true,
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'common',
    i18n: {
        defaultLocale: 'default',
        locales: ['default', 'zh-HK', 'en-US'],
        localeDetection: false,
    },
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    fallbackLng: {
        default: ['en-US'],
    },
};
